import { duration } from 'moment';
import React, { FC } from 'react';
import { TaskEstimateChanged } from 'api/notifications/meta';
import { useTranslation } from 'hooks/use-translation';
import { FieldChangedMessage } from './field-changed';

export const TaskEstimateChangedView: FC<{ meta: TaskEstimateChanged }> = ({
  meta: { by, from, to },
}) => (
  <FieldChangedMessage
    name={useTranslation('fields.estimate')}
    by={by}
    from={from ? <>{duration(from.value, 'h').humanize()}</> : null}
    to={to ? <>{duration(to.value, 'h').humanize()}</> : null}
  />
);
